export default function AuthorCard({
  name,
  role,
  image,
}: {
  name: string;
  role: string;
  image: string;
}) {
  return (
    <div className="flex items-center gap-4">
      <img src={image} alt="Author" className="h-10 w-10 rounded-full" />
      <div className="flex flex-col">
        <h1 className="text-[18px] font-medium">{name}</h1>
        <p className="text-lighterBlack text-[13px]">{role}</p>
      </div>
    </div>
  );
}
